const overviewCardEnum = [
  // {
  //   key: "child_count",
  //   name: "支线总人数",
  //   url: "/administrationCenter/subordinateManagement",
  //   type: "number",
  // },
  // {
  //   key: "child_register_count",
  //   name: "注册人数",
  //   url: "/administrationCenter/subordinateManagement",
  //   type: "number",
  // },
  // {
  //   key: "first_deposit_user_count",
  //   name: "首存人数",
  //   url: "/reportManagement/downlineReport",
  //   type: "number",
  // },
  {
    key: "deposit_user_count",
    name: "存款人数",
    url: "/reportManagement/financialReport",
    type: "number",
  },
  {
    key: "withdrawal_user_count",
    name: "提款人数",
    url: "/reportManagement/financialReport",
    type: "number",
  },
  {
    key: "bet_user_count",
    name: "有效投注人数",
    url: "/reportManagement/downlineReport",
    type: "number",
  },
  {
    key: "sum_win_loss",
    name: "净输赢",
    url: "/reportManagement/downlineReport",
    type: "money",
  },
  {
    key: "sum_promotion_rebate_amount",
    name: "总优惠红利返水",
    url: "/reportManagement/financialReport",
    type: "money",
  },
  {
    key: "sum_first_deposit_amount",
    name: "首存金额",
    url: "/reportManagement/financialReport",
    type: "money",
  },
  {
    key: "sum_deposit_amount",
    name: "总存款",
    url: "/reportManagement/financialReport",
    type: "money",
  },
  {
    key: "sum_withdrawal_amount",
    name: "总提款",
    url: "/reportManagement/financialReport",
    type: "money",
  },
  {
    key: "sum_bet_amount",
    name: "有效投注总额",
    url: "/administrationCenter/subordinateManagement",
    type: "money",
  },
];

export default overviewCardEnum;
